export const defaultScopeId = "v3.notifications";

export const SUBSCRIBE = "NOTIFICATION/SUBSCRIBE";
export const UNSUBSCRIBE = "NOTIFICATION/UNSUBSCRIBE";
export const LOAD_REQUESTED = "NOTIFICATION/LOAD_REQUESTED";
export const LOAD_SUCCEEDED = "NOTIFICATION/LOAD_SUCCEEDED";
export const LOAD_FAILED = "NOTIFICATION/LOAD_FAILED";
export const UPDATE_READ_REQUESTED = "NOTIFICATION/UPDATE_READ_REQUESTED";
export const UPDATE_READ_SUCCEEDED = "NOTIFICATION/UPDATE_READ_SUCCEEDED";
export const UPDATE_READ_FAILED = "NOTIFICATION/UPDATE_READ_FAILED";

const findById = notificationId => ({ _id }) =>  notificationId === _id;

// eslint-disable-next-line max-statements
export default (state = {
    errors: [],
    hasInitialData: false,
    loading: false,
    notifications: [],
    subscriptions: 0,
    updating: 0,
    v2docs: [],
}, { type, data }) => {
    switch (type) {
    case SUBSCRIBE: {
        ++state.subscriptions;
        return state;
    }
    case UNSUBSCRIBE: {
        --state.subscriptions;
        return state;
    }
    case LOAD_REQUESTED: {
        state.loading = true;
        return state;
    }
    case LOAD_SUCCEEDED: {
        state.notifications = data.notifications || [];
        state.v2docs = data?.v2docs || [];
        state.loading = false;
        state.hasInitialData = true;
        return state;
    }
    case LOAD_FAILED: {
        state.errors.push({ ...data, type });
        state.loading = false;
        return state;
    }
    case UPDATE_READ_REQUESTED: {
        data.forEach(notificationId => {
            const notification = state.notifications.find(findById(notificationId));
            if (notification){
                notification.updating = true;
            }
            ++state.updating;
        });
        return state;
    }
    case UPDATE_READ_SUCCEEDED: {
        data.forEach(({ _id, ...opts }) => {
            Object.assign(state.notifications.find(findById(_id)) || {}, {
                updating: false,
                ...opts
            });
            --state.updating;
        });
        return state;
    }
    case UPDATE_READ_FAILED: {
        state.errors.push({ ...data, type });
        const { notifications } = data;
        notifications.forEach(({ _id }) => {
            const notification = state.notifications.find(findById(_id));
            if (notification){
                notification.updating = false;
            }
            --state.updating;
        });
        return state;
    }
    default: return state;
    }
};

export const subscribeNotifications = data => ({ type: SUBSCRIBE, data });
export const unsubscribeNotifications = data => ({ type: UNSUBSCRIBE, data });
export const requestNotificationsLoad = (data, resolve, reject) => ({ type: LOAD_REQUESTED, data, resolve, reject });
export const succeedNotificationsLoad = data => ({ type: LOAD_SUCCEEDED, data });
export const failNotificationsLoad = data => ({ type: LOAD_FAILED, data });
export const requestNotificationsUpdateRead = (data, resolve, reject) => ({ type: UPDATE_READ_REQUESTED, data, resolve, reject });
export const succeedNotificationsUpdateRead = data => ({ type: UPDATE_READ_SUCCEEDED, data });
export const failNotificationsUpdateRead = data => ({ type: UPDATE_READ_FAILED, data });
